import { computed, ref, watch, watchEffect } from 'vue';
import { useStore } from '@/store/index'
import EtapasComponentesConstant from '@/constants/EtapasComponentesConstant';
import FuncoesHelper from '@/helpers/FuncoesHelper';
import StatusComponenteConstant from '../constants/StatusComponenteConstant';
// import StatusComponenteConstant from '@/constants/StatusComponenteConstant';

/* eslint-disable no-unused-vars */
class ResumoService {
    setup() {
        const store = useStore()
        const checklistFinalizado = computed(() => store.state.recebimentoFinalizado)
        const identificador =  ref(FuncoesHelper.obterParametrosRota('identificador'))
        const localRealizacao =  ref(FuncoesHelper.obterParametrosRota('localRealizacao'))
        const modulo =  ref(FuncoesHelper.obterParametrosRota('modulo'))
        const preview =  ref(FuncoesHelper.validarChecklistPreview())
        const modulos = computed(() => store.state.modulos)
        
        const modulosResumo = ref([])
        const dadosComponentes = ref({})
        const componentesEtapa = ref([])
        const assinaturas = ref({})
        const totalEtapas = ref(0)

        const dadosRespostas = ref({})
        const checklistValido = ref(true)
        const exibirLoader = ref(false)
        const assinado = ref(false)
        const checklistSalvo = ref(false)
        const finalizadoComSucesso = ref(false)
        const componentesResumo = ref([])

        watchEffect(() => {
            if (modulos.value) {
                modulosResumo.value = modulos.value.filter(module => parseInt(module.idChecklistModulo) !== parseInt(modulo.value))
                const moduloAtual = modulos.value.find(module => module.idChecklistModulo == modulo.value)
                
                if (moduloAtual) {
                    totalEtapas.value = moduloAtual.etapas.totalEtapas
                    dadosComponentes.value = moduloAtual.etapas.componentes
                    assinaturas.value = moduloAtual.assinaturas

                    for (let etapa in dadosComponentes.value) {
                        const componenteEtapa = dadosComponentes.value[etapa]
                        for (let subkey in componenteEtapa) {
                            const subcomponente = componenteEtapa[subkey]

                            const etapas = EtapasComponentesConstant.ETAPAS;
                            const etapaChave = subcomponente.chave;
                            if (etapas && etapas[etapaChave]) {
                                if (!componentesEtapa.value.some((item) => item.chave === etapaChave)) {
                                    componentesEtapa.value.push({
                                        etapa,
                                        chave: etapaChave,
                                        ...etapas[etapaChave],
                                    });
                                }
                            } else {
                                subcomponente.componenteMenu.forEach((componenteMenu) => {
                                    if (!componentesEtapa.value.some((item) => item.chave === componenteMenu)) {
                                        if (etapas && etapas[componenteMenu]) {
                                            componentesEtapa.value.push({
                                                etapa,
                                                chave: componenteMenu,
                                                ...etapas[componenteMenu],
                                            });
                                        }
                                    }
                                });
                            }
                        }
                    }
                }

                if(modulosResumo.value.length > 0 && moduloAtual.ordem > 1) {
                    modulosResumo.value.forEach(moduloResumo => {
                        const componenteModulo = {
                            idChecklistModulo: moduloResumo.idChecklistModulo,
                            localRealizacao: moduloResumo.localRealizacao,
                            componentes: []
                        }
                        Object.entries(moduloResumo.etapas.componentes).forEach(([etapa, componenteEtapa]) => {
                            Object.entries(componenteEtapa).forEach(([subkey, subcomponente]) => {
                                componenteModulo.componentes.push(subcomponente)
                            })
                        })
                        componentesResumo.value.push(componenteModulo)
                    })
                }
            }
        })
        
        watchEffect(() => {
            let pendentes = {};
            if (dadosComponentes.value) {

                Object.entries(dadosComponentes.value).forEach(([etapa, componenteEtapa]) => {
                    Object.entries(componenteEtapa).forEach(([subkey, subcomponente]) => {
                        const { chave, identificador } = subcomponente;
                        if(chave === 'dadosAtendimento') {
                            return;
                        }
                        if (chave !== 'dadosAtendimento' && chave !== 'texto' && subcomponente.status === 'pendente') {
                            pendentes[identificador] = { ...subcomponente, etapa };
                        }
                        
                        if(chave == 'texto' && (subcomponente.respostas == null || subcomponente.respostas.resposta == '')) {
                            if(StatusComponenteConstant.PENDENTE.chave === subcomponente.status) {
                                pendentes[identificador] = { ...subcomponente, etapa };
                            }
                        }
        
                        dadosRespostas.value[identificador] = { ...subcomponente, etapa };
                    });
                });
                if (Object.keys(pendentes).length > 0 && preview.value === false) {
                    dadosRespostas.value = pendentes;
                    checklistValido.value = false;
                }
            }
            if (Object.keys(assinaturas.value).length > 0 && assinaturas.value.respostas !== null) {
                if(assinaturas.value.opcoes && assinaturas.value.respostas) {
                    assinado.value = Object.keys(assinaturas.value.opcoes).length === Object.keys(assinaturas.value.respostas).length;
                }
                setTimeout(() => {
                    window.scrollTo({
                        top: document.body.scrollHeight,
                        behavior: 'smooth'
                    });
                }, 100)
            }
        });
        
        watch(checklistFinalizado, (finalizado) => {
            checklistFinalizado.value = finalizado
        })

        return {
            dadosRespostas,
            exibirLoader,
            totalEtapas,
            assinado,
            checklistSalvo,
            checklistFinalizado,
            assinaturas,
            checklistValido,
            componentesEtapa,
            finalizadoComSucesso,
            identificador,
            localRealizacao,
            modulo,
            componentesResumo,
            preview,
            dadosComponentes
        }
    }
}

export default new ResumoService()